import { AxiosInstance } from "axios";
import { deleteEmptyFields  } from '~/utils/helpers';
import { httpError } from "~/api/common";

export enum EvPortType {
  CCS_1 = 'CCS 1',
  CCS_2 = 'CCS 2',
  CHAdeMO = 'CHAdeMO',
  GBT_AC = 'GB/T AC',
  GBT_DC = 'GB/T DC',
  TYPE_1 = 'Type 1',
  TYPE_2 = 'Type 2',
  TYPE_2_PLUG = 'Type 2 Plug',
  TYPE_2_TYPE_1 = 'Type 2/Type 1',
}

export default class EvPortsApi {
  rootPath: string = "/ev-port-articles";
  instance: AxiosInstance = {} as AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    httpError.addSource(this.rootPath, 'title.evPorts')
  }

  getAll = (limit: number = 10, page: number = 1, query?: Api.GetEvPortsQuery ): Promise<Api.EvPortsResponse> =>
    this.instance.get(this.rootPath, { params: { limit, skip: (page - 1) * limit, ...deleteEmptyFields(query || {}) } });

  deleteEvPorts = (ids: string[]): Promise<Api.Response<{}>> =>
    this.instance.delete(this.rootPath, { params: { ids } })

  getEvPort = (id: string): Promise<Api.EvPortResponse> =>
    this.instance.get(`${this.rootPath}/${id}`)

  createEvPort = (data: Api.CreateEvPort): Promise<Api.GetOne<Api.EvPortDto>> =>
    this.instance.post(this.rootPath, data)

  updateEvPort = (id: string, data: Api.UpdateEvPort): Promise<Api.GetOne<Api.EvPortDto>> =>
    this.instance.put(`${this.rootPath}/${id}`, data)

  deleteEvPort = (id: string): Promise<Api.Response<{}>> =>
    this.instance.delete(`${this.rootPath}/${id}`)
}
